import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const goToSection = (sectionId) => {
    if (isHome) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate(`/#${sectionId}`);
    }
    closeMenu();
  };

  return (
    <motion.nav
      className={`navbar ${scrolled ? "scrolled" : ""}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="nav-container">
        <motion.div
          className="nav-logo"
          whileHover={{ scale: 1.05 }}
          onClick={() => goToSection("home")}
        >
          <h2>Lars & Guro</h2>
        </motion.div>

        <ul className={`nav-menu ${isOpen ? "active" : ""}`}>
          <li>
            <button
              onClick={() => goToSection("home")}
              className="nav-link"
            >
              Hjem
            </button>
          </li>
          <li>
            <button
              onClick={() => goToSection("schedule")}
              className="nav-link"
            >
              Program
            </button>
          </li>
          <li>
            <button
              onClick={() => goToSection("locations")}
              className="nav-link"
            >
              Steder
            </button>
          </li>
          <li>
            <button
              onClick={() => goToSection("rsvp")}
              className="nav-link"
            >
              RSVP
            </button>
          </li>
          <li>
            <a href="/wishlist" className="nav-link nav-anchor" onClick={closeMenu}>
              Ønskeliste
            </a>
          </li>
          <li>
            <a href="/galleri" className="nav-link nav-anchor" onClick={closeMenu}>
              Galleri
            </a>
          </li>
        </ul>

        <div
          className={`hamburger ${isOpen ? "active" : ""}`}
          onClick={toggleMenu}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;
